module.exports = __webpack_public_path__ + "img/GTE.90605d0f.svg";